module.exports = "/static-assets/_next/static/images/downloadOnAppStore-00b41df7855c7ca6821ac41f6bebeaab.svg";